import React from 'react';
import { TextField, Box, Typography } from '@mui/material';

const SimpleInput = ({
  type = 'text',
  name,
  value = '',
  onChange,
  placeholder,
  label,
  required = false,
  error = false,
  errorMessage = '',
  helperText = '',
  maxLength = '', // renamed to camelCase (standard in React)
}) => {
  // Calculate character count only when maxLength exists
  const charCount = maxLength ? `${value.length}/${maxLength}` : '';

  return (
    <Box>
      {label && (
        <Typography
          variant="body2"
          sx={{
            mb: 1,
            fontWeight: 500,
            color: 'grey.700',
            fontSize: '0.875rem',
          }}
        >
          {label}
          {required && <span style={{ color: 'red', marginLeft: 4 }}>*</span>}
        </Typography>
      )}

      <TextField
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        variant="outlined"
        fullWidth
        error={error}
        helperText={error ? errorMessage : charCount || helperText}
        
        // This is how you limit input length
        inputProps={{
          maxLength: maxLength || undefined, // only apply if value exists
        }}
        
        sx={{
          '& .MuiOutlinedInput-root': {
            py: 1,
            px: 1.5,
            borderRadius: 1,
            '& fieldset': {
              borderColor: error ? 'error.main' : 'grey.300',
            },
            '&:hover fieldset': {
              borderColor: error ? 'error.main' : 'grey.400',
            },
            '&.Mui-focused fieldset': {
              borderColor: error ? 'error.main' : 'primary.main',
              borderWidth: 2,
            },
          },
          '& .MuiOutlinedInput-input': {
            py: 1,
            px: 1.5,
          },
        }}
      />
    </Box>
  );
};

export default SimpleInput;